import { REMOVE_PARAM_LIST } from 'components/CardNavigationPanel/constants';

// ドリルダウンtype定数
export const LOCATION_DRILL_DOWN_TYPES = {
  PREFECTURE: 'prefecture',
  CITY: 'city',
  WARD: 'ward',
} as const;

/**
 * ドリルダウンで引き継がないクエリパラメータ
 */
export const REMOVE_PARAMS_FOR_DRILL_DOWN = [
  ...REMOVE_PARAM_LIST,
  'pf',
  'page',
  'prsrt',
];
